<template>
<div>
    <NavBar
    :clienteName="model.clienteName"
    :logoUrl="model.companiaLogoUrl"
    v-on:suscripciones="openSuscripcionListModal()"
    />
    <!-- Sub vista -->
    <div class="contenedor-contenido">
        <router-view></router-view>
    </div>
    <SuscripcionListModal
      v-if="model.showSuscripcionListModal"
      @close="closeSuscripcionListModal()"
      v-on:suscripcion-cancelada="suscripcionCanceled"
    />

    <Footer />
</div>
</template>
<script>
import { environment } from "../../../environments/environment";
import Footer from './Footer.vue';
import NavBar from './NavBar.vue';
import SuscripcionListModal from "./SuscripcionListModal.vue";

export default {
components:{
    Footer,
    NavBar,
    SuscripcionListModal,
},
data(){
    return {
        model:{
            clienteName: undefined,
            // TODO: get the backup logo from the server
            companiaLogoUrl: environment.API_SB_URL + 'images/logos/' + localStorage.getItem('logoCompania'),
            showSuscripcionListModal: false,
        }
    }
},
methods:{
    openSuscripcionListModal(){
        this.model.showSuscripcionListModal = true;
    },
    closeSuscripcionListModal(){
        this.model.showSuscripcionListModal = false;
    },
    suscripcionCanceled(beneficio){
        this.$store.commit("beneficioUpdate", {beneficioId: beneficio.id, data: {suscripto: false}});
    }
},
mounted(){
    this.model.clienteName = localStorage.getItem("user");
}
}
</script>
<style scoped>
.contenedor-contenido {
  padding-bottom: 70px;
}
</style>